export default __webpack_public_path__ + "static/210521_妲絲刷關活動熱更預告_sc-a244dd09179493bfdac9257f1e24aa22.png";